import {useSelector} from 'react-redux';

import {refreshTokenUserSelector} from 'src/redux/selectors/user';

export default function useAuth() {
  const refreshToken = useSelector(refreshTokenUserSelector);

  return {isSignedIn: !!refreshToken};
}
